
        import * as module0 from './javascripts/compilers/button.js';import * as module1 from './javascripts/compilers/map.js';import * as module2 from './javascripts/compilers/print.js';import * as module3 from './javascripts/compilers/prompt_button.js'

        const modules = [module0,module1,module2,module3];

        export default modules;
        export const filenames = ['./javascripts/compilers/button.js','./javascripts/compilers/map.js','./javascripts/compilers/print.js','./javascripts/compilers/prompt_button.js']
      